import React, { Component } from "react";
import { AccordionCarrousel } from "../AccordionCarrousel";
import { AccordionDetails } from "../AccordionDetails";
import { CopyYourLink } from "../CopyYourLink";

import styles from "./styles.css";

export class AccordionContainer extends Component {
  state = {
    isOpenAccordion: true,
  };

  render() {
    const {
      image_url,
      title,
      rewards,
      price,
      amount,
      onlyView,
      awards,
      user
    } = this.props;
    const { isOpenAccordion } = this.state;

    if (!awards) {
      return '';
    }
    if (!rewards) {
      return '';
    }

    if(!user){
      return '';
    }

    return (
      <section className={styles.container}>
        <header className={styles.HeaderAccordion}>
          <img src={image_url} alt={title} />
          <div className={styles.ColumnHeader}>
            <div>
              <span>
                Indique e ganhe<br />
                Próximo prêmio: <b>{title}</b>
              </span>
              <span>
                <b>{amount}</b>/{price}
              </span>
            </div>
            <div className={styles.Progressbar}>
              <div
                className={styles.Progress}
                style={{ width: `${(amount/price)*100}%` }}
              />
            </div>
          </div>
          {!onlyView && (
            <button
              onClick={() =>
                this.setState({ isOpenAccordion: !isOpenAccordion })
              }
            >
              {isOpenAccordion ? (
                <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
              <path d="M8.2 275.4c0-8.6 3.4-17.401 10-24.001 13.2-13.2 34.8-13.2 48 0l451.8 451.8 445.2-445.2c13.2-13.2 34.8-13.2 48 0s13.2 34.8 0 48L542 775.399c-13.2 13.2-34.8 13.2-48 0l-475.8-475.8c-6.8-6.8-10-15.4-10-24.199z"></path>
              </svg>
              ) : (
                <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 1024 1024"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8.2 751.4c0 8.6 3.4 17.401 10 24.001 13.2 13.2 34.8 13.2 48 0l451.8-451.8 445.2 445.2c13.2 13.2 34.8 13.2 48 0s13.2-34.8 0-48L542 251.401c-13.2-13.2-34.8-13.2-48 0l-475.8 475.8c-6.8 6.8-10 15.4-10 24.2z"></path>
              </svg>
              )}
            </button>
          )}
        </header>
        <section className={isOpenAccordion ? styles.Closed : styles.Show}>
          <AccordionDetails
            image={rewards.image}
            title={rewards.name}
            description={rewards.description}
            benefits={rewards.benefits}
          />
          <AccordionCarrousel items={awards} />
          <CopyYourLink link={user.shared_link} />
        </section>
        <footer className={styles.Footer}>
          {/* <b>SPRINTA REWARDS</b>      */}
          <span dangerouslySetInnerHTML={{__html: rewards.benefits}} />
                 
          

          <button
            onClick={() => this.setState({ isOpenAccordion: !isOpenAccordion })}
          >
            Saiba mais
          </button>
        </footer>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/PrizeAccordion/AccordionContainer/index.jsx